import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon } from '@fortawesome/pro-light-svg-icons/faMoon';
import { faSun } from '@fortawesome/pro-light-svg-icons/faSun';
import { TypedMemo } from '../../../common/types';
import { useSMLTheme } from '../../theme/useSMLTheme';
import { SMLTheme } from '../../theme/smlTheme';
import { accountMenuMessages as messages } from './accountMenuMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the account menu and sheet */
import styles from './AccountMenu.module.scss';
/* eslint-enable css-modules/no-unused-class */

const OPTIONS: { theme: SMLTheme; icon: typeof faMoon; label: typeof messages.themeDark }[] = [
  { theme: 'dark', icon: faMoon, label: messages.themeDark },
  { theme: 'light', icon: faSun, label: messages.themeLight },
];

/**
 * design: navigation-v2 6a, 7d (nav.css .seg2). The Theme row of the account menu: dark and
 * light. The lit side is the theme on screen, so a "system" choice lights the device scheme. A
 * click stores the explicit choice.
 */
const AccountThemeSegmentComponent: React.FC = () => {
  const intl = useIntl();
  const { theme, setTheme } = useSMLTheme();

  return (
    <span className={styles.segment} role="radiogroup" aria-label={intl.formatMessage(messages.theme)}>
      {OPTIONS.map((option) => {
        const isOn = option.theme === theme;
        return (
          <button
            key={option.theme}
            type="button"
            role="radio"
            aria-checked={isOn}
            aria-label={intl.formatMessage(option.label)}
            title={intl.formatMessage(option.label)}
            className={clsx(styles.segmentOption, isOn && styles.segmentOn)}
            onClick={() => setTheme(option.theme)}
          >
            <FontAwesomeIcon icon={option.icon} />
          </button>
        );
      })}
    </span>
  );
};

export const AccountThemeSegment = TypedMemo(AccountThemeSegmentComponent);
